import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { SystemNames } from './system-names.model';
import * as SystemNamesActions from './system-names.actions';

export const systemNamesesFeatureKey = 'systemNameses';

export interface State extends EntityState<SystemNames> {
  // additional entities state properties
}

export const adapter: EntityAdapter<SystemNames> = createEntityAdapter<SystemNames>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(SystemNamesActions.addSystemNames,
    (state, action) => adapter.addOne(action.systemNames, state)
  ),
  on(SystemNamesActions.upsertSystemNames,
    (state, action) => adapter.upsertOne(action.systemNames, state)
  ),
  on(SystemNamesActions.addSystemNamess,
    (state, action) => adapter.addMany(action.systemNamess, state)
  ),
  on(SystemNamesActions.upsertSystemNamess,
    (state, action) => adapter.upsertMany(action.systemNamess, state)
  ),
  on(SystemNamesActions.updateSystemNames,
    (state, action) => adapter.updateOne(action.systemNames, state)
  ),
  on(SystemNamesActions.updateSystemNamess,
    (state, action) => adapter.updateMany(action.systemNamess, state)
  ),
  on(SystemNamesActions.deleteSystemNames,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(SystemNamesActions.deleteSystemNamess,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(SystemNamesActions.loadSystemNamess,
    (state, action) => adapter.setAll(action.systemNamess, state)
  ),
  on(SystemNamesActions.clearSystemNamess,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
